module.exports = __webpack_public_path__ + "franchise-07.png?292e7298d491d189be2138793b9b214b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/franchise-07.png
// module id = 268
// module chunks = 0